import React from 'react';
import LinearGradient from '@/components/basic/linear-gradient';
import Text from '@/components/basic/text';
import theme from '@/style';
import {StyleSheet, View} from 'react-native';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';

const DigitTab = ({
  type: _type,
  pickThreeId: _pickThreeId = 0,
  refreshCode: _refreshCode = 0,
  setIndex = () => {},
  index = 0,
  orderNum,
}: {
  type?: string;
  pickThreeId?: number;
  refreshCode?: number;
  index?: number;
  orderNum?: number;
  setIndex?: (v: number) => void;
}) => {
  const tablist = [
    {
      title: 'Result',
      key: 'result',
    },
    {
      title: 'My order',
      key: 'order',
    },
  ];

  return (
    <LinearGradient
      colors={['#FFFFFF', '#F4F6FB']}
      style={[styles.wrap, theme.padding.lrl]}>
      <View style={styles.tabRow}>
        {tablist.map((item, _i) => (
          <NativeTouchableOpacity
            key={item.key}
            onPress={() => setIndex(_i)}
            style={styles.tabItem}>
            <View style={styles.labelWrap}>
              <Text
                fontSize={14}
                fontFamily={_i === index ? 'fontInterBold' : 'fontInter'}
                color={_i === index ? '#31373D' : '#5F6975'}>
                {item.title}
              </Text>
              {item.key === 'order' && Boolean(orderNum) ? (
                <View style={styles.badge}>
                  <Text
                    fontSize={10}
                    fontFamily="fontInterBold"
                    color={theme.basicColor.white}>
                    {orderNum}
                  </Text>
                </View>
              ) : null}
            </View>
            {_i === index ? <View style={styles.activeLine} /> : null}
          </NativeTouchableOpacity>
        ))}
      </View>
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  wrap: {
    height: 48,
    justifyContent: 'flex-end',
    paddingBottom: 8,
  },
  tabRow: {
    flexDirection: 'row',
  },
  tabItem: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 6,
  },
  labelWrap: {
    position: 'relative',
  },
  activeLine: {
    width: 20,
    height: 4,
    borderRadius: 999,
    backgroundColor: theme.basicColor.primary,
  },
  badge: {
    position: 'absolute',
    right: -12,
    top: -8,
    minWidth: 16,
    height: 16,
    paddingHorizontal: 3,
    borderRadius: 999,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.basicColor.primary,
  },
});

export default React.memo(DigitTab);
